import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MessageCircleIcon, InstagramIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { CATALOGO_URL, CONTACTO, VCARS_LOGO } from '../data/brand';
const nav: {
  label: string;
  to: string;
  external?: boolean;
}[] = [{
  label: 'Catálogo',
  to: CATALOGO_URL,
  external: true
}, {
  label: 'Financiación',
  to: '/financiacion'
}, {
  label: 'Vendé tu auto',
  to: '/vender-mi-auto'
}, {
  label: 'Permutas',
  to: '/permutas'
}, {
  label: 'Contacto',
  to: '/contacto'
}];
const accesos = [{
  label: `WhatsApp ${CONTACTO.ventasNombre}`,
  detail: `${CONTACTO.ventasTelefono} · Ventas`,
  href: whatsappLink(GENERAL_WA_MESSAGE, CONTACTO.ventasWhatsapp),
  icon: MessageCircleIcon,
  tone: 'text-[#25c264]',
  external: true
}, {
  label: 'WhatsApp Administración',
  detail: `${CONTACTO.adminTelefono} · Administración general`,
  href: whatsappLink(GENERAL_WA_MESSAGE, CONTACTO.adminWhatsapp),
  icon: PhoneIcon,
  tone: 'text-[#25c264]',
  external: true
}, {
  label: 'Email',
  detail: CONTACTO.email,
  href: `mailto:${CONTACTO.email}`,
  icon: MailIcon,
  tone: 'text-neon',
  external: false
}, {
  label: 'Instagram',
  detail: CONTACTO.instagramUsuario,
  href: CONTACTO.instagram,
  icon: InstagramIcon,
  tone: 'text-neon',
  external: true
}];
export function Footer() {
  return <footer className="border-t border-neon/25 bg-surface" data-id="element-33" data-mp="34gvzesy8n6j">
      <div className="mx-auto w-full max-w-7xl px-5 py-14 md:px-8 md:py-16" data-id="element-34" data-mp="31uoff6267ob">
        <div className="grid gap-10 lg:grid-cols-[1.15fr_0.8fr_1.25fr] lg:gap-14" data-id="element-35" data-mp="hsadj51lhzrr">
          <div data-id="element-36" data-mp="cus3tcfr7gip">
            <div className="flex items-center gap-2.5" data-id="element-37" data-mp="cu8tagsfnuep">
              <img src={VCARS_LOGO} alt="Logo de VCARS" className="h-11 w-11 rounded-full object-cover ring-1 ring-neon/40" data-id="element-38" data-mp="qt05tyrnd80q" />
              <span className="text-lg font-black tracking-[0.18em] text-neon-soft" data-id="element-39" data-mp="tvd13wd6udh9">
                VCARS
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-mist" data-id="element-40" data-mp="yupl89cod6g5">
              Usados seleccionados, 0KM, financiación, permutas y gestión de ventas
              particulares.
            </p>
            <p className="mt-4 flex items-start gap-2 text-sm text-mist" data-id="element-41" data-mp="18lk6bae6q000">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-42" data-mp="1ckknypkxewlf" />
              {CONTACTO.ubicacion}
            </p>
          </div>

          <nav aria-label="Enlaces del sitio" data-id="element-43" data-mp="1mktpmixota87">
            <h3 className="text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-44" data-mp="1mhxsgwtnypkt">
              Secciones
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-45" data-mp="3obolfarw99ex">
              {nav.map(l => <li key={l.label} data-id="element-46" data-mp="3ta8c1ohfn9dm">
                  {l.external ? <a href={l.to} target="_blank" rel="noopener noreferrer" className="text-sm text-mist transition-colors duration-150 ease-smooth hover:text-white" data-id="element-47" data-mp="3tccbnu8atm83">
                      {l.label}
                    </a> : <Link to={l.to} className="text-sm text-mist transition-colors duration-150 ease-smooth hover:text-white" data-id="element-48" data-mp="1woi9i0dnqrl7">
                      {l.label}
                    </Link>}
                </li>)}
            </ul>
          </nav>

          <div data-id="element-49" data-mp="2kbgmgo2kjhed">
            <h3 className="text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-50" data-mp="2kf4grpfu87u5">
              Contacto VCARS
            </h3>
            <ul className="mt-4 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-51" data-mp="18ynxfl15x720">
              {accesos.map(({
              label,
              detail,
              href,
              icon: Icon,
              tone,
              external
            }) => <li key={label} data-id="element-52" data-mp="141e8e6hoqxep">
                  <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="flex items-center gap-3 rounded-xl border border-line bg-surface2/40 px-4 py-3 transition-[border-color,box-shadow] duration-150 ease-smooth hover:border-neon/60 hover:shadow-[0_0_24px_-14px_rgba(31,123,255,0.95)]" data-id="element-53" data-mp="2rvhg7o2icb82">
                    <Icon className={`h-4 w-4 shrink-0 ${tone}`} aria-hidden="true" data-id="element-54" data-mp="3bhm4hg65ji7a" />
                    <span className="min-w-0" data-id="element-55" data-mp="3fkiuhry0ugl9">
                      <span className="block text-[13.5px] font-semibold text-white" data-id="element-56" data-mp="31m2c33qsr1na">
                        {label}
                      </span>
                      <span className="block truncate text-[12.5px] text-mist" data-id="element-57" data-mp="36j2lnomuumj5">
                        {detail}
                      </span>
                    </span>
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-line/70" data-id="element-58" data-mp="1nkmqmf2m6t82">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-5 py-6 text-[13px] text-mist md:flex-row md:items-center md:justify-between md:px-8" data-id="element-59" data-mp="1imuzvodphd5g">
          <p data-id="element-60" data-mp="1wm43lokq6esj">© {new Date().getFullYear()} VCARS. Todos los derechos reservados.</p>
          <p data-id="element-61" data-mp="1rom5yuc5rlzu">Vendé, comprá o financiá tu próximo auto con asesoramiento profesional.</p>
        </div>
      </div>
    </footer>;
}